import "./styles/certificate_form.css";
import { useRef, useState } from "react";
import { printContent } from '../../utils/printUtils';
import DynamicMessage from "./dynamic_message";


const CertificateDetails = ({ selectedItem }) => {
  const printableBusinessPermitRef = useRef(null);
  const printBusinessPermit = () => {
    const divContents = printableBusinessPermitRef.current.innerHTML;
    const additionalStyles = `
    .bt_bp {
      border-top: 1px solid #28a745;
    }
    `;
    printContent(divContents, additionalStyles);
  };


  const [hasPhoto, setHasPhoto] = useState(false);
  const [hasThumbmark, setHasThumbmark] = useState(false)
  const [hasSignature, setHasSignature] = useState('');


  return (
    <>
      {selectedItem && (
        <>

         
          <button type="button" className="btn btn-success mb-2" onClick={printBusinessPermit}>Print Document</button>

          <div ref={printableBusinessPermitRef} className="certificate container m-0" style={{ padding: '13px', paddingTop: 0, paddingBottom: 0 }}>
            <div className="row header pt-2" style={{ backgroundImage: "url('/iusevolutione/assets/img/bahay_toro/bahaytoro_logo_header.png')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: "215px", }}>
              <div className="col text-center ms-2">
                <img src="/iusevolutione/assets/img/bahay_toro/bahaytoro_logo.png" alt="Logo" className="img-fluid" />
              </div>
              <div className="col-7 text-center header-text">
                <p className="fs-3 fw-bolder m-0">Republic of the Philippines</p>
                <h5 className="m-0">Quezon City</h5>
                <h1 className="m-0">Barangay Bahay Toro</h1>
                <p className="m-0">(Office of the Punong Barangay)</p>
                <p className="m-0">Address: #1 Road 12 corner Road 11, Barangay Bahay Toro, QC</p>
                <p>Email: <u className="text-info">barangaybahaytoro1@gmail.com</u></p>
              </div>
              <div className="col text-center me-2">
                <img src="/iusevolutione/assets/img/bahay_toro/lungsod_quezon_logo.png" alt="Logo" className="img-fluid" />
              </div>
            </div>
            <div className="row m-0" style={{
              backgroundImage: "url('/iusevolutione/assets/img/bahay_toro/bahaytoro_logo_body.png')",
              backgroundSize: "cover", // or "cover" depending on your needs
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              height: "750px", // Set your desired height
              width: "100%",
            }}>
              <div className="col-3 mt-n3" style={{ borderRight: "8px solid #A9D18E" }}>
                <div className="footer officials mt-5 fw-bold text-center" >
                  <p className="fs-6">VICTOR V. FERRER JR.<br /><span className="fst-italic">Punong Barangay</span></p>
                  <p className="fs-6 fst-italic">Barangay Kagawad<br /></p>
                  <p>MARIA EDITHA T. ALCANTARA<br /></p>
                  <p>DOMINGO G. YANG<br /></p>
                  <p>RAYMUNDO B. HERRERA<br /></p>
                  <p>OFELIA M. MEIMBAN<br /></p>
                  <p>MARIA TERESA A. REYES<br /></p>
                  <p>MARK S. BAGUINO<br /></p>
                  <p>ROMEO R. SANTOS<br /></p>
                  <p>ROSS DANICA ESTHER L. IGNACIO<br /><span>SK Chairperson</span></p>
                  <p>ALLAN VENTURA JR.<br /><span>Barangay Secretary</span></p>
                  <p>JESSICA DELOS REYES<br /><span>Barangay Treasurer</span></p>
                </div>
              </div>
              <div className="col">
                <div className="col-12 h-auto">
                  <div className="content">
                    
                    <DynamicMessage details={selectedItem}  updateHasSignature={setHasSignature} updateHasPhoto={setHasPhoto} updateHasThumbmark={setHasThumbmark}  />


                    <div className="mt-5" >
                      <div className="col-12 d-flex justify-content-between">


                        <div className="text-center">
                          {hasSignature && <p><b>{hasSignature}</b><br />Applicant's Signature</p>}
                          
                        </div>


                        <div className="text-center">
                          <p><b>VICTOR V. FERRER JR. CPA, MBA</b><br />Punong Barangay</p>
                        </div>
                      </div>


                      
                     
                     
                      <div className="row footer">
                        <div className="col-12 text-start">

                          <div className="col-12 d-flex justify-content-start">
                            <img src={selectedItem.qr_code_path} alt="QR Code" className="img-fluid mb-2 border border-success" style={{ width: '120px',height:'120px' }} />
                            {hasPhoto && selectedItem.images.length > 0 && (<img src={`${selectedItem.images[0].image_path}`} className="img-fluid mb-2 border border-success ms-2 bg-white" style={{ width: '120px',height:'120px' }} />) }
                            {hasThumbmark && (
                            
                           
                            <div className="text-center">
                               <img alt="thumbmark" className="img-fluid mb-2 border border-success ms-2 bg-white" style={{ width: '120px',height:'120px' }} />
                              <p><b>Thumbmark</b></p>
                            </div>
                            
                            ) }
                          </div>
                          
                          <p className="py-0 my-0">PRIL 035</p>
                            <small className="fw-bold">NOT VALID WITHOUT SEAL. Valid only within six (6) months from date of issuance.</small>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>

               

              </div>

            </div>

            <div className="row header align-items-center d-" style={{ backgroundImage: "url('/iusevolutione/assets/img/bahay_toro/bahaytoro_logo_footer.png')", marginTop: '-26px', backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: "130px", }}></div>

          </div>
        </>
      )}

    </>
  );
}

export default CertificateDetails;